<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da página -->
          <basic-toolbar :title="'Finalizar participação do membro da equipe'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

              <!-- Nome -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label='Nome'
                    :value="this.participanteProjetoPesquisa.nome === null || this.participanteProjetoPesquisa.nome === '' ? '-' : this.participanteProjetoPesquisa.nome"
                    readonly
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <!-- Data final -->
              <v-layout row>
                <v-flex xs12>
                  <c-date-dialog
                    label="Data final*"
                    v-model="participanteProjetoPesquisa.dataFinal"
                    :rules="obrigatorio"
                  >
                  </c-date-dialog>
                </v-flex>
              </v-layout>

              <br>

              </v-container>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Salvar" -->
              <v-btn color="primary" :disabled="!formularioValido" @click="finalizaParticipanteProjetoPesquisa()">Salvar</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import DataDialog from '@/components/c-date-dialog'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa', 'idParticipanteProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      participanteProjetoPesquisa: {
        situacao: ''
      },
      listaTiposParticipacao: [],
      obrigatorio: [v => !!v || 'Este campo é obrigatório']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Finaliza a participação do membro da equipe do projeto de pesquisa.
      finalizaParticipanteProjetoPesquisa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando participação do membro da equipe do projeto de pesquisa...' })
        this.participanteProjetoPesquisa.situacao = 'I'
        projetos.putParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisa, this.participanteProjetoPesquisa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaEquipe'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando participação do membro da equipe do projeto de pesquisa...' })
        })
      },

      // Redireciona para a página anterior.
      cancelar: function () {
        this.$router.go(-1)
      }
    },
    mounted () {
      // Carrega o participante do projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando membro da equipe do projeto de pesquisa...' })
      projetos.getParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisa)
      .then(response => {
        this.participanteProjetoPesquisa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando membro da equipe do projeto de pesquisa...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-date-dialog': DataDialog
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// finalizar-membro-equipe.vue?e6acecae